var map = {
	"./buy/index": [
		"f50d",
		"chunk-commons",
		"vendors~balance~inputs0~inputs1~inputs2~inputs3~inputs4~transport",
		"inputs0~inputs2~inputs3~inputs4",
		"inputs0"
	],
	"./losses/index": [
		"69c3",
		"chunk-commons",
		"vendors~balance~inputs0~inputs1~inputs2~inputs3~inputs4~transport",
		"inputs1"
	],
	"./sale/index": [
		"bb7c",
		"chunk-commons",
		"vendors~balance~inputs0~inputs1~inputs2~inputs3~inputs4~transport",
		"inputs0~inputs2~inputs3~inputs4",
		"inputs2"
	],
	"./transport_cost/index": [
		"18a1",
		"chunk-commons",
		"vendors~balance~inputs0~inputs1~inputs2~inputs3~inputs4~transport",
		"inputs0~inputs2~inputs3~inputs4",
		"inputs3"
	],
	"./transport_gain/index": [
		"32c4",
		"chunk-commons",
		"vendors~balance~inputs0~inputs1~inputs2~inputs3~inputs4~transport",
		"inputs0~inputs2~inputs3~inputs4",
		"inputs4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bd4f";
module.exports = webpackAsyncContext;